import { useRSO } from "@/api/services/main/rso";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { RsoDetail } from "@/features/rso/components/RsoDetail";
import { useSyncMeOrgName } from "@/hooks/useSyncMeOrgName";

export const RsoPage = () => {
  const { data: rsoResponse, isLoading } = useRSO();
  const rsoData = rsoResponse?.data;

  // 連携同期で RSO 名が変わったら、詳細の値をヘッダー (useMe) にも反映する。
  useSyncMeOrgName({ type: "rso", id: rsoData?.id, name: rsoData?.name });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!rsoData) return null;

  return <RsoDetail data={rsoData} />;
};
